import React from 'react';
import { EntryFormProps } from '../types';
import EntryForm, { useEntryFormErrors } from './EntryForm';
import EntrySheet from './EntrySheet';

interface NewEntryFormProps extends EntryFormProps {
  patientId?: string;
  visitId?: string;
  onCancel: () => void;
  onSave: () => void;
  onFinalize?: () => void;
  saving?: boolean;
  isReadOnly?: boolean;
  /** Phase 18U U9: when the draft was last kept on this device */
  savedAt?: Date | null;
  /** The "Resume unsaved … ?" banner for this form */
  draftNotice?: React.ReactNode;
}

/**
 * A new chart entry. Phase 18U U3: the form opens in an EntrySheet with Save and Cancel pinned
 * in the footer (it used to render inline with Save at the top of the form).
 */
const NewEntryForm: React.FC<NewEntryFormProps> = ({
  selectedEntryType,
  patientId,
  visitId,
  onCancel,
  onSave,
  onFinalize,
  isMobile,
  saving = false,
  isReadOnly = false,
  savedAt = null,
  draftNotice = null,
  ...formProps
}) => {
  // Phase 18 M1: Save stays disabled until the form is valid
  const errors = useEntryFormErrors(selectedEntryType, formProps);
  const invalid = Object.keys(errors).length > 0;

  return (
    <EntrySheet
      open
      entryType={selectedEntryType || 'notes'}
      mode="new"
      onCancel={onCancel}
      onSave={onSave}
      saving={saving}
      invalid={invalid}
      isReadOnly={isReadOnly}
      savedAt={savedAt}
      notice={draftNotice}
      touch={isMobile}
    >
      <EntryForm
        selectedEntryType={selectedEntryType}
        {...formProps}
        isMobile={isMobile}
        isReadOnly={isReadOnly}
      />
    </EntrySheet>
  );
};

export default NewEntryForm;
